export default __webpack_public_path__ + "static/media/image.seeamles-solutions.4bc81f25.png";